import { useCallback, useState } from 'react';
import SubscriptionsRepository from '@/finsight/infrastructure/repository/SubscriptionsRepository';
import { AlertManager } from '@dealroadshow/uikit/core/components/Alert';
import { getErrorMessage } from '@/Framework/Message/Mapper/getMessage';
import { useDIContext } from '@/Framework/DI/DIContext';
import { IUserSubscriptionsResponse } from '@/finsight/domain/vo/Subscriptions/userSubscriptions';

export const useGetUserSubscriptions = () => {
  const { container } = useDIContext();
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [userSubscriptions, setUserSubscriptions] = useState<IUserSubscriptionsResponse>({});
  const getUserSubscriptions = useCallback(async () => {
    try {
      setIsFetching(true);
      const subscriptionsRepository = container.get(SubscriptionsRepository);
      const response = await subscriptionsRepository.getUserSubscriptionsBySSID();
      setUserSubscriptions(response);
    } catch (error) {
      AlertManager.error(getErrorMessage(error));
    } finally {
      setIsFetching(false);
    }
  }, []);

  return {
    userSubscriptions,
    getUserSubscriptions,
    isFetching,
  };
};
